import axios from "axios";
import { getUserPreference } from "../utilities/common";

/**
 * @param {Object} params
 * Search by time period
 * @param {string} params.report_type
 * @param {Number} params.start_time
 * @param {Number} params.end_time
 * @param {string} params.nums_of_report
 * @param {string} params.driver_id
 * Search by batch
 * @param {Number} params.report_type
 * @param {string} params.nums_of_report
 * @param {string} params.driver_id
 * @param {string} params.batch_number
 * @param {string} params.reference
 * Search by TNO's
 * @param {string} params.report_type
 * @param {string} params.tnos
 */
export function downloadPodQualityExcelBlob(params) {
    return axios.post(`${process.env.REACT_APP_NEW_DRIVER_SERVER_URL}/delivery/pods/report`, params, {
        responseType: 'blob',
        headers: {
            'Authorization': `Bearer ${getUserPreference().authToken}`
        },
        timeout: 0
    })
    .then((response) => {
        if (response.headers['content-type'] === "application/json") {
            return Promise.reject(response);
        } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'POD Quality.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    })
    .catch((error) => {
        return Promise.reject(error);
    })
}
  